<template>
    <div class="home-container">
        <!-- 导航 -->
        <RMTopDiv :scroll100="scroll100" :scroll700="scroll700"></RMTopDiv>   
        <div class="top_bg">
            <div class="container_box">
                <div style="font-size: 50px;">商学院文化</div>
                <div style="font-size: 20px;margin-top: 20px;font-size: 20px;">梦想起航，筑梦美业新生态</div>
            </div>
        </div>
        <div class="middle_box">
            <div class="min_box">
                <div class="min_down"></div>
                <div class="min_img">
                    <img src="../../static/img/school/sign.png" alt="">
                </div>
            </div>
            <div class="small_box">
                <div class="school_top">Business School Culture</div>
                <div style="display: flex;margin-top: 30px;">
                    <div class="icon"><img src="../../static/img/school/icon.png" alt="" style="width: 100%;height: 100%;"></div>
                    <div class="school_title">商学院文化</div>
                </div>
                <div class="school_line"></div>
                <div class="school_text">  
                    牵手阿里强强联合推进中国美业快速电商化，帮助美业商家拓客、引流、信息同享、资源整理、提高商家成交率，感受互联网公司的开放创新空间，体验阿里的管理与文化魅力。
                </div>
            </div>
        </div>
        <div style="width: 1200px;margin: 0 auto;margin-top: 73px;">
            <div style="display: flex;align-items: center">
                <div style="color: #343434">
                    <div style="font-size: 34px;">MEIFUZX</div>
                    <div style="font-size: 26px;margin-top: 12px">商学院体系</div>
                </div>
                <div style="background: #D8E1E0;width: 694px;height: 2px;"></div>
            </div>
            <div class="sys_top">
                <img src="../../static/img/school/book.png" alt="" style="width: 100%;height: 100%;">
                <div class="sys">
                    <div class="sys_left">
                        <div class="sys_left_1">商学院体系</div>
                        <div class="sys_left_2">思维开放的起点</div>
                        <div class="sys_left_3">
                            中国美业专注“实效”、并坚持将之实践的领导品牌；打造美业“干部训练”与“项目运营”两个核心主题；首次推出美业“阿里游学”；拥有服务10000家连锁店的成功经验与模式；拥有20多名最具实力的实战型顾问和讲师团队；拥有10多年打造出的完美教育培训体系；拥有20多个全国深度合作机构和分公司；与阿里巴巴及国内知名行业大咖建立合作联盟。
                        </div>
                    </div>
                    <div class="sys_right">
                        <img src="../../static/img/school/img8.png" alt="" style="width: 100%;height: 100%;">
                    </div>
                </div>
            </div>
        </div>
        <!-- 尾部 -->
        <RMBottomDiv style="margin-top: 454px;"></RMBottomDiv>
    </div>
</template>

<script>
    import RMTopDiv from '../../src/page/RMTopDiv.vue'
    import RMBottomDiv from '../../src/page/RMBottomDiv.vue'
    import { mapGetters } from "vuex";
    import { mapMutations } from "vuex";
    import * as types from "../store/mutation-types";
    export default {
        components: {RMTopDiv,RMBottomDiv},
        data() {
            return {
                scroll: '',
                scroll100: true,
                scroll700: false
            };
        },
        watch: {
            scroll: function () {
                this.loadSroll();
            }
        },
        methods: {
            //首页
            goToHome() {
                this.$router.push('/')
            },
            //产品中心-店务系统介绍
            goToDw() {
                this.$router.push('./home')
            },
            //产品中心-供应链
            goToSupply() {
                this.$router.push('./supplyChain')
            },
            //产品中心-营销工具
            goToMark() {
                this.$router.push('./marketingTools')
            },
            //关于我们-公司简介
            goToUS() {
                this.$router.push('./company')
            },
            //关于我们-合作渠道
            goToChannel() {
                this.$router.push('./channels')
            },
            //关于我们-招聘
            goToContact() {
                this.$router.push('./contact')
            },
            //关于我们-企业文化
            goToCulture() {
                this.$router.push('./culture')
            },
            //找美商学院-商学院文化
            goToCollege() {
                this.$router.push("./school");
            },
            //找美商学院-走进阿里
            goToAli() { 
                this.$router.push("./Ali");
            },
            //找美商学院-行程安排
            gotoTravell() { 
                this.$router.push('./Travell')
            },
            //找美商学院-讲师简介
            goToTeach() { },
            //找美商学院-相关案例
            goToCase() { },
            dataScroll(event) {
                this.scroll = document.documentElement.scrollTop || document.body.scrollTop || event.target.scrollTop
            },
            loadSroll: function () {
                if (this.scroll <= 100) {
                    this.scroll100 = true
                } else {
                    this.scroll100 = false
                }
                if (this.scroll > 100) {
                    this.scroll700 = true
                } else {
                    this.scroll700 = false
                }
            },
        },
        created() {

        },

        computed: {
            ...mapGetters(["username", "password", "treeData", "stafftype", "limit"])

        },
        mounted() {
            //获取高度
            window.addEventListener("scroll", this.dataScroll, true);
        }
    };
</script>

<style scoped lang="scss">
    @import "../assets/css/them.scss";

    .home-container {
        background-color: #fff;
        width: 100%;
        height: 100%;
        position: fixed;
        overflow-y: scroll;
    }

    .top_bg {
        background-image: url('../../static/img/school/banner.png');
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        width: 100%;
        height: 824px;
        position: relative;
        top: 0;
        left: 0;
    }

    .container_box {
        z-index: 1000;
        position: absolute;
        top: 38%;
        left: 0;
        color: #fff;
        text-align: center;
        width: 100%;
        min-width: 769px;
    }

    .middle_box {
        width: 1200px;
        margin: 0 auto;
        margin-top: 63px;
        display: flex;
    }

    .min_box {
       width: 642px;
       height: 639px;
       position: relative;
    }
    .min_down{
        width: 566px;
        height: 566px;
        background:rgba(255,255,255,1);
        border:8px solid rgba(238,120,42,1);
    }
    .min_img {
        width: 579px;
        height: 579px;
        position: absolute;
        top: 60px;
        left: 63px;
    }

    .small_box {
       margin-top: 83px;
       margin-left: 124px;
    }
    .school_top{
        font-size: 50px;
        color: #E87529;
        line-height: 70px;
        height: 140px;
        font-weight: 500;
    }
    .icon{
        width: 31px;
        height: 28px;
    }
    .school_title {
        font-size: 26px;
        color: #252525;
        margin-left: 6px;
    }
    .school_line{
        width: 470px;
        height: 4px;
        background: #EE782A;
        margin-top: 31px;
    }
    .school_text {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        width: 477px;
        color: #565656;
        margin-top: 31px;
        line-height: 33px;
        letter-spacing: 1px;
    }

    .sys_top {
        margin-top: 17px;
        width: 1200px;
        height: 524px;
        position: relative;
    }

    .sys {
        width: 1200px;
        height: 454px;
        margin: 0 auto;
        margin-top: -100px;
        /* position: absolute;
        top: 422px;
        left: 0; */
        display: flex
    }

    .sys_left {
        width: 657px;
        height: 454px;
        margin-left: 75px;
        background: #fff;
    }

    .sys_left_1 {
        font-size: 26px;
        color: #252525;
        margin-left: 69px;
        margin-top: 51px;
        font-weight: 500;
        font-family: PingFangSC-Regular, PingFang SC;
    }

    .sys_left_2 {
        font-size: 16px;
        color: #999;
        margin-left: 69px;
        margin-top: 7px;
    }

    .sys_left_3 {
        font-size: 18px;
        color: #565656;
        margin-left: 69px;
        margin-top: 27px;
        width: 524px;
        /* margin-right: 64px; */
        line-height: 30px;
        text-indent: 25px;
        letter-spacing: 1px;
    }

    .sys_right {
        width: 239px;
        height: 288px;
        margin-left: 139px;
        margin-top: 166px;
    }
    
</style>


// WEBPACK FOOTER //
// src/page/school.vue